import { render, staticRenderFns } from "./bookingLogs.vue?vue&type=template&id=3b924db6&scoped=true"
import script from "./bookingLogs.vue?vue&type=script&lang=js"
export * from "./bookingLogs.vue?vue&type=script&lang=js"
import style0 from "./bookingLogs.vue?vue&type=style&index=0&id=3b924db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b924db6",
  null
  
)

export default component.exports